module.exports = __webpack_public_path__ + "img/Self-consumption.9d6efe82.svg";